module.exports = __webpack_public_path__ + "static/media/favicon.a3306f2f.ico";